/* eslint-disable @typescript-eslint/no-unnecessary-type-assertion, @typescript-eslint/consistent-type-assertions */
import { Controller } from "stimulus";
import type FilterCount from "./filter-count.stimulus";

export default class FilterClear extends Controller {
	static outlets = ["filter-count"];

	declare filterCountOutlets: Array<FilterCount>;

	clear() {
		this.element
			.querySelectorAll("input[type=checkbox]")
			.forEach((checkbox: HTMLInputElement) => (checkbox.checked = false));
		this.refreshAllOutlets();
		(
			this.element.querySelector("input[type=radio][value='']") as HTMLInputElement
		).checked = true;
	}

	refreshAllOutlets() {
		this.filterCountOutlets.forEach((c) => c.refresh());
	}
}
